import { isEmptyObject, removeUndefinedAndNullProperties } from 'lib/object/objectUtils'

function sanitizeItemContextMetadata(props: any): string | undefined {
  const metadata = removeUndefinedAndNullProperties(props)
  if (!isEmptyObject(metadata)) {
    return JSON.stringify(metadata)
  }
}
export default sanitizeItemContextMetadata
